<template>
    <div>
        <div class="title-config">
            <div class="title">{{ $f.tc('blackList') }}</div>
            <div style="display: flex; align-items: center" v-if="enableBlackList===true">
                <div class="btn-outline" @click="importBlacklist">
                    <img
                        src="/img/add-blue.svg"
                        alt="icon-import-excel"
                        style="margin-right: 6px; transform: scale(1.2)"
                    >
                    {{ $f.tc('addNewExcel') }}
                </div>
                <div
                    class="btn-outline mr-0" style="width: 32px"
                    @click="downloadTemplate"
                    :title="$f.tc('downloadTemplateExcel')"
                >
                    <img src="/img/scenario/download_blue.svg" alt="icon-download-template">
                </div>
                <input
                    type="file"
                    :hidden="true"
                    ref="inputBlacklist" accept=".xlsx, .xls, .csv"
                    @change="handleFile"
                >
            </div>
        </div>
        <div class="fci-scrollbar config-content">
            <div class="display-flex align-center" style="padding: 20px 20px 0 20px">
                <div class="label" style="margin-bottom: 0 !important;">{{ $f.tc('activeBlackList') }}</div>
                <v-switch
                    style="margin-left: 10px"
                    color="#0052cc"
                    v-model="enableBlackList"
                    @change="updateStatusCampaign"
                    hide-details
                ></v-switch>
            </div>
            <v-form
                class="display-flex align-center"
                style="padding: 12px 20px 20px 20px; border-bottom: 1px solid #E4EDFA;"
                v-model="formValid"
                @submit="submit" ref="form"
                v-if="enableBlackList===true"
            >
                <v-text-field
                    outlined
                    v-model="emptyItem.phone_number"
                    class="input-custom"
                    :rules="[formRules.ruleRequired, formRules.rulePhone]"
                    :placeholder="$f.tc('phone')"
                ></v-text-field>
                <div class="btn-outline ml-8 mr-0" @click="submit">
                    <img src="/img/add-blue.svg" alt="icon-add-blacklist"
                         style="transform: scale(1.2); margin-right: 6px">
                    {{ $f.tc('add') }}
                </div>
            </v-form>
            <div
                class="blacklist fci-scrollbar"
                v-if="enableBlackList===true"
            >
                <div class="centerY justify-space-between">
                    <div class="centerY">
                        <div class="btn-outline-delete mr-8" v-if="selected.length > 0" @click="deleteMultiPhone(false)">
                            <img src="/img/delete_red.svg" alt="icon-delete-selected" class="mr-6">
                            {{ $f.tc('deleteSelected') }} ({{ selected.length }})
                        </div>
                        <div class="btn-delete" @click="deleteMultiPhone(true)">
                            <img src="/img/delete_white.svg" alt="icon-delete-all" class="mr-6">
                            {{ $f.tc('deleteAll') }}
                        </div>
                    </div>
                    <div class="search-box">
                        <v-text-field
                            v-model="filter.phone"
                            class="input-custom"
                            @keydown.enter="search(1)"
                            :placeholder="$f.tc('search')"
                        ></v-text-field>
                        <img
                            src="/img/scenario/search.svg"
                            alt="icon-search"
                            class="icon-search"
                            @click="search(1, $event)"
                        >
                    </div>
                </div>
                <div class="mt-12">
                    <SimpleDataTable
                        :headers="headers"
                        :items="dataTable"
                        :current-page="filter.page"
                        :total-page="totalPage"
                        :items-per-page="filter.rowsPerPage"
                        :total-items="totalItems"
                        :selectable="true"
                        :showSelectedNav="false"
                        @updateSelected="updateSelected"
                        @page-change="search($event, filter.itemPerPage)"
                        @item-per-page-change="search(1, $event)"
                    >
                        <template v-slot:action="props">
                            <v-btn icon small @click="deleteItemBlacklist(props.item)">
                                <img src="/img/delete-blue.svg" alt="icon-delete"
                                     style="transform: scale(1.1); padding-left: 1px">
                            </v-btn>
                        </template>
                    </SimpleDataTable>
                </div>
                <BlacklistCreator ref="BlacklistCreator"></BlacklistCreator>
            </div>
        </div>
    </div>
</template>

<script>
import CampaignService from "@/services/campaign.service"
import BaseConfig from "@/views/Campaign/Form/Step4/BaseConfig"
import BlacklistCreator from "@/views/Campaign/Form/Step4/BlacklistCreator"
import FormMixin from "@/modules/fptai/mixins/FormMixin"
import SimpleDataTable from "@/components/SimpleDataTable"

export default {
    name: "BlackListConfig",
    extends: BaseConfig,
    mixins: [FormMixin],
    components: {
        SimpleDataTable,
        BlacklistCreator
    },
    data() {
        return {
            emptyItem: {
                phone_number: ''
            },
            file: '',
            enableBlackList: false,
            dataTable: [],
            filter: {
                phone: '',
                page: 1,
                rowsPerPage: 10,
            },
            totalPage: 1,
            totalItems: 0,
            selected: []
        }
    },
    computed: {
        itemTranslate() {
            return this.$t('mailReport')
        },
        headers() {
            return [
                {
                    text: this.$filters.capitalize(this.$t('phone')),
                    value: 'phone_number',
                    sortable: false
                },
                {
                    text: this.$filters.capitalize(this.$t('createBy')),
                    value: 'created_by',
                    sortable: true
                },
                {
                    text: this.$filters.capitalize(this.$t('action')),
                    value: 'action',
                    sortable: false,
                    type: 'custom',
                    id: 'action'
                }
            ]
        }
    },
    mounted() {
        this.search()
        this.enableBlackList = this.campaign.enable_black_list
    },
    methods: {
        submitValidForm() {
            CampaignService.BlacklistService.create(this.campaign.id, {
                phone_number: this.emptyItem.phone_number
            }).then(() => {
                this.clearForm()
                this.search()
                this.$appService.toastSuccess(this.$f.tc('addBlacklistSuccess'))
            })
        },
        search(page, itemsPerPage) {
            this.filter.page = page ? page : this.filter.page
            this.filter.rowsPerPage = itemsPerPage ? itemsPerPage : this.filter.rowsPerPage
            this.$appService.showLoading()
            CampaignService.BlacklistService.search(this.campaign.id, {
                ...this.filter,
                search: this.filter.phone
            }).then(
                result => {
                    this.dataTable = result.data.data
                    this.totalItems = result.data.count || result.data.total
                    this.totalPage = Math.ceil(this.totalItems / this.filter.rowsPerPage)
                },
                this.$appService.handleRequestError()
            ).finally(this.$appService.hideLoading)
        },
        deleteItemBlacklist(item) {
            this.$appService.confirm(this.$t('confirmDelete', {item: item.phone_number})).then(
                confirm => {
                    if (confirm) {
                        const i18n = {
                            action: this.$t('delete'),
                            item: this.$t('phone')
                        }
                        CampaignService.deleteBlackList(this.campaign.id, item.id).then(
                            () => {
                                this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                                this.search()
                            })
                    }
                }
            )
        },
        deleteMultiPhone(isDeleteAll) {
            this.$appService.confirm(
                this.$f.tc(isDeleteAll ? 'confirmDeleteAllBlacklist' : 'confirmDeleteSelectedBlacklist'),
                this.$f.tc('deleteBlacklistNotice', [`${isDeleteAll ? this.totalItems : this.selected.length}`])
            ).then(
                confirm => {
                    if (!confirm) {
                        return
                    }

                    this.$appService.showLoading()
                    if (isDeleteAll) {
                        CampaignService.deleteAllBlacklist(this.campaign.id).then(() => {
                            this.$appService.toastSuccess(`${this.$f.tc('deleteAll')} ${this.$t('successful')}`)
                            this.search(1, null)
                        }).catch(this.$appService.hideLoading)
                    } else {
                        let phoneList = this.selected.map(i => i.phone_number)
                        CampaignService.deleteSelectedBlacklist(this.campaign.id, phoneList).then(() => {
                            this.$appService.toastSuccess(`${this.$f.tc('deleteSelected')} ${this.$t('successful')}`)
                            this.search(1, null)
                        }).catch(this.$appService.hideLoading)
                    }
                }
            )
        },
        updateStatusCampaign() {
            this.$store.dispatch(this.$actionTypes.campaign.UPDATE_CAMPAIGN, {
                campaign: this.campaign,
                model: {
                    enable_black_list: this.enableBlackList
                }
            })
        },
        importBlacklist() {
            this.$refs.inputBlacklist.click()
        },
        handleFile(event) {
            this.file = event.target.files[0]
            let extFile = this.file.name.split('.').pop()
            if (['xlsx', 'csv', 'xls'].includes(extFile)) {
                let formData = new FormData()
                formData.append('file', this.file)
                this.$appService.showLoading()
                this.$http.post(
                    `/campaigns/${this.campaign.id}/import-black-list-phone-number/`,
                    formData,
                    {headers: {'Content-Type': 'multipart/form-data'}}
                ).then(
                    () => {
                        this.search()
                        this.$appService.toastSuccess('success')
                    }
                ).catch(
                    err => {
                        this.$appService.toastError(err.toString())
                    }
                ).finally(() => {
                    this.$appService.hideLoading()
                    this.file = null
                    this.$refs.inputBlacklist.value = null
                })

            } else {
                this.$appService.toastError('invalid file')
            }
        },
        downloadTemplate() {
            CampaignService.getBlackListTemplate(this.campaign).then(res => {
                this.$utils.saveFile(res.data, this.$filters.replaceSpecialCharacters(this.$utils.nonAccentVietnamese(this.campaign.title + ' - black list template')), '.xlsx')
            })
        },
        updateSelected(selected) {
            this.selected = selected
        }
    }
}
</script>
<style lang="scss" scoped>
.title-config {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 20px;
    border-bottom: 1px solid #E4EDFA;
}

.search-box {
    width: 250px;
    position: relative;

    .icon-search {
        cursor: pointer;
        width: 16px;
        position: absolute;
        top: 8px;
        right: 10px;
    }
}

.btn-outline {
    margin-right: 8px;
}

.row-config {
    display: flex;
    align-items: center;

    .config-key, .config-value {
        width: 317px;
        margin-right: 8px;
    }

    .config-action {
        width: 32px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.btn-icon {
    height: 32px;
    width: 32px;
}

.btn-delete {
    height: 32px !important;
    line-height: 32px !important;
    border-radius: 5px !important;
    text-transform: none !important;
    padding: 0 12px 0 11px !important;
    font-weight: 400 !important;
    background: #dc3545 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    font-size: 14px;
    white-space: nowrap;
    user-select: none;
    font-family: "open sans", serif;

    &:hover {
        background: #dc3545bf !important;
    }
}


.blacklist {
    padding: 20px 20px 20px 20px;
    height: calc(100vh - 398px);
    overflow-y: auto;
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px;
    }

    .v-input--selection-controls {
        padding-left: 0 !important;
        margin-top: 0 !important;
        margin-bottom: 1px;
    }

    tr {
        td:last-child {
            width: 100px !important;
            text-align: center;
        }
    }

    .v-table__overflow {
        border: 1px solid #96add0;
    }

    table.v-table thead tr {
        height: 43px !important;
    }

    .data-table table.v-table thead th {
        background: #E4EDFA;
        text-transform: capitalize !important;
        color: #12274F !important;
    }

    .theme--light.v-table thead tr:first-child {
        border-bottom: 1px solid #96add0 !important;
    }

    .v-datatable__progress {
        display: none;
    }

    .pager-wrap {
        padding: 8px 16px !important;
    }
}
</style>
